import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  flex: 0 0 1px;\n  height: 2rem;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  justify-content: center;\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  align-items: center;\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
var Wrapper = styled.div(_templateObject(), function (p) {
  return p.theme.fontCss('body');
});
var FooterLink = styled.a(_templateObject2(), function (p) {
  return p.theme.grey3;
}, function (p) {
  return p.theme.grey3;
});
var FooterDivider = styled.div(_templateObject3(), function (p) {
  return p.theme.grey3;
});

var Footer = function Footer() {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(FooterLink, {
    href: "mailto:support@some.domain"
  }, "support@some.domain"), /*#__PURE__*/React.createElement(FooterDivider, null), /*#__PURE__*/React.createElement(FooterLink, {
    href: "tel:18006481179"
  }), /*#__PURE__*/React.createElement(FooterDivider, null), /*#__PURE__*/React.createElement(FooterLink, {
    href: "https://resources.some.domain/content/privacy"
  }, "Privacy Policy"), /*#__PURE__*/React.createElement(FooterDivider, null), /*#__PURE__*/React.createElement(FooterLink, {
    href: "https://resources.some.domain/content/terms-and-conditions"
  }, "Terms of Service"));
};

export default Footer;